export default __webpack_public_path__ + "static/media/chat-communication-gold.c90d2f23.svg";